export const packageList = [
  {
    name: 'tms_followfly',
    activeRule: ['tms-followfly']
  },
  {
    name: 'tms_ycar',
    activeRule: ['tms-ycar']
  },
  {
    name: 'tmsreport',
    activeRule: ['tmsreport']
  },
  {
    name: 'tms_follow',
    activeRule: ['tms-follow']
  },
  {
    name: 'tms_stowage',
    activeRule: ['tms-stowage']
  },
  {
    name: 'tms_dispatch',
    activeRule: ['tms-dispatch']
  },
  {
    name: 'oms',
    activeRule: ['oms']
  },
  {
    name: 'tms',
    activeRule: ['dbc', 'tms', 'jpms', 'tms-trunkline', 'tms-message', 'tms-common', 'tms-basic-data'],
  },
  {
    name: 'tms_bill',
    activeRule: ['tms-bill']
  },
  {
    name: 'freight',
    activeRule: ['freight']
  },
  {
    name: 'tms_agent',
    activeRule: ['tms-agent']
  },
  {
    name: 'tms_outside',
    activeRule: ['tms-outside']
  },
  {
    name: 'tms_partner',
    activeRule: ['tms-partner']
  },
  {
    name: 'tms_global_logistics',
    activeRule: ['tms-global-logistics']
  },
  {
    name: 'tms_warehouse',
    activeRule: ['tms-warehouse']
  },
  {
    name: 'oem_digital_display',
    activeRule: ['oem-digital-display']
  },
  {
    name: 'tms_kts',
    activeRule: []
  },
  {
    name: 'tms_flow',
    activeRule: []
  }
]

export const remoteModuleConfig = {
  dev: ['tms_followfly', 'tms_ycar', 'tmsreport', 'tms_follow', 'tms_stowage', 'tms_dispatch', 'oms', 'tms', 'tms_bill', 'freight', 'tms_agent', 'tms_outside', 'tms_partner', 'tms_global_logistics', 'tms_warehouse', 'oem_digital_display', 'tms_kts', 'tms_flow'],
  stg: ['tms_followfly', 'tms_ycar', 'tmsreport', 'tms_follow', 'tms_stowage', 'tms_dispatch', 'oms', 'tms', 'tms_bill', 'freight', 'tms_agent', 'tms_outside', 'tms_partner', 'tms_global_logistics', 'tms_warehouse', 'oem_digital_display', 'tms_kts', 'tms_flow'],
  uat: ['tms_followfly', 'tms_ycar', 'tmsreport', 'tms_follow', 'tms_stowage', 'tms_dispatch', 'oms', 'tms', 'tms_bill', 'freight', 'tms_agent', 'tms_outside', 'tms_partner', 'tms_global_logistics', 'tms_warehouse', 'oem_digital_display', 'tms_kts', 'tms_flow'],
  prd: ['tms_followfly', 'tms_ycar', 'tmsreport', 'tms_follow', 'tms_stowage', 'tms_dispatch', 'oms', 'tms', 'tms_bill', 'freight', 'tms_agent', 'tms_outside', 'tms_partner', 'tms_global_logistics', 'tms_warehouse', 'oem_digital_display', 'tms_kts', 'tms_flow'],
}



// WEBPACK FOOTER //
// ./src/layout/router/remote/package-list/tms/index.js